import { render, staticRenderFns } from "./exchange-goods-details.vue?vue&type=template&id=17c8899c&scoped=true&"
import script from "./exchange-goods-details.vue?vue&type=script&lang=js&"
export * from "./exchange-goods-details.vue?vue&type=script&lang=js&"
import style0 from "./exchange-goods-details.vue?vue&type=style&index=0&id=17c8899c&prod&lang=scss&"
import style1 from "./exchange-goods-details.vue?vue&type=style&index=1&id=17c8899c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c8899c",
  null
  
)

export default component.exports